var _ = require("../../../uam/module.js")(module.exports, {
  namespace: "ua.preview.access",
  title: "Access Preview",
  description: "Preview renderer for ua.access control values.",
  supportServer: false,
  fields: {
    value: { title: "Value", type: "object", description: "Access policy value." },
    name: { title: "Name", type: "string", description: "Control name." }
  }
});

function safe(value) {
  return (value || "").toString().trim();
}

function lower(value) {
  return safe(value).toLowerCase();
}

function normalizePolicy(value) {
  var policy = lower(value);
  if (!(policy)) return "public";
  return policy;
}

function normalizeExpiry(value) {
  var expiry = lower(value);
  if (expiry === "unlimited" || expiry === "no-expiration" || expiry === "never") return "none";
  if (expiry === "24h" || expiry === "7d" || expiry === "30d" || expiry === "none") return expiry;
  return "none";
}

function summaryText(value) {
  var data = (value && typeof value === "object") ? value : {};
  var policy = normalizePolicy(data.policy || data.type);

  if (policy === "shared-secret") return "Shared secret required";
  if (policy === "logged-in") return "Any logged-in user";
  if (policy === "role") {
    var roles = data.accessRoles || data.roles || data.role || data.requiredRole || [];
    if (!(roles instanceof Array)) roles = [roles];
    roles = roles.map(function(item) { return safe(item).toLowerCase(); }).filter(Boolean);
    if (roles.length === 0) return "When a user has one of these roles: none selected";
    return "When a user has one of these roles: " + roles.join(", ");
  }
  if (policy === "email") {
    var emails = data.emails || [];
    if (!(emails instanceof Array)) emails = [];
    return "Emails: " + (emails.length > 0 ? emails.join(", ") : "None");
  }
  if (policy === "secure-link") {
    var expiry = normalizeExpiry((data.secureLinkExpiry || data.secureLinkExpiresIn || "none"));
    var label = expiry === "24h" ? "24 hours" : expiry === "7d" ? "7 days" : expiry === "30d" ? "30 days" : "No expiration";
    return "Secure link (" + label + ")";
  }
  return "Public";
}

exports.render = async function(options) {
  var text = summaryText((options || {}).value);
  return {
    n: "span",
    c: "ua-control-preview-text",
    i: text
  };
};
